import { connect } from 'react-redux';
import AboutUs from './about-us';

export const mapStateToProps = state => ({
  ...state.aboutUs,
  isMobile: state.browser.is.mobile
});

export default connect(mapStateToProps)(AboutUs);
